/**
 * The Symagic Server Assignment entity.
 * @author Maarten Lensink
 */
import * as moment from 'moment';
/**
 * The Symagic Server Attendant entity.
 */
var Attendant = /** @class */ (function () {
    function Attendant() {
        this.service = undefined;
    }
    Object.defineProperty(Attendant.prototype, "Duration", {
        /**
         * Gets the difference between Start and Finish.
         * There is a server-side property Duration with the same meaning.
         * We choose to calculate client-side for instant user feedback.
         * @type {string}
         */
        get: function () {
            // if (!this.entityAspect || this.entityAspect.entityState === EntityState.Added) {
            if (!this.entityAspect) {
                return 'PT0S';
            }
            if (!this.Finish || !this.Start) {
                return 'PT0S';
            }
            var start = moment(this.Start);
            var finish = moment(this.Finish);
            if (start.isAfter(finish)) {
                return 'PT0S';
            }
            var result = moment.duration(finish.diff(start));
            return result.toISOString();
        },
        /**
         * Sets nothing. Only needed for angular binding.
         */
        set: function (value) {
            // Make it a read/write property to enable twoway binding.
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Attendant.prototype, "Service", {
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (!this.service && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.service;
        },
        set: function (value) {
            if (value && value !== this.service && this.entityAspect.entityState.isAdded()) {
                // Fix: Een nieuwe attendant in de dienstenlijst krijgt als default voor Start en Eind StartBase en FinishBase van de service #2805
                this.Start = value['StartBase'];
                this.Finish = value['FinishBase'];
                this.Name = value['Name'];
                this['SumFactor'] = value['SumFactor'];
            }
            this.service = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the effort by factoring the ratio of overlap with a given timeslot.
     * @param {moment.Moment} start The start of the timeslot
     * @param {moment.Moment} finish The finish of the timeslot.
     * @returns {number} The effort ratio in seconds
     */
    Attendant.prototype.overlapEffort = function (start, finish) {
        var factor = this.SumFactor;
        if (factor === 0) {
            return 0;
        }
        if (start.isSameOrAfter(this.Finish)) {
            return 0;
        }
        if (finish.isSameOrBefore(this.Start)) {
            return 0;
        }
        var planStart = moment(this.Start);
        var planFinish = moment(this.Finish);
        var overlapStart = start.isAfter(planStart) ? start : planStart;
        var overlapFinish = finish.isBefore(planFinish) ? finish : planFinish;
        var overlap = moment.duration(overlapFinish.diff(overlapStart)).asSeconds();
        return factor * overlap;
    };
    return Attendant;
}());
export { Attendant };
